import { useMutation } from "react-query"
import api from "../client"
import { queryClient, queryKeys } from "../query"

const postData = async (uuid: string | undefined) => {
    const { data } = await api.post(
        `/orders/${uuid}/cancel`,
    )

    queryClient.invalidateQueries(queryKeys.ORDER(uuid))
    queryClient.invalidateQueries(["orders"], { refetchInactive: true })

    return data
}

export const useCancelOrder = (uuid: string | undefined) => {
    return useMutation(() => {
        return postData(uuid)
    })
}
